<template>
  <div v-if="!item.hidden">
    <template v-if="typeof(item.children)=='undefined' || item.children.length==0 || item.meta.isDashboard">
      <app-link v-if="item.meta" :to="item.meta.fullPath">
        <el-menu-item :index="item.meta.fullPath" :class="{'submenu-title-noDropdown':!isNest}" @click="toggleSideBar" >
          <m-item :icon="item.meta.icon||(item.meta&&item.meta.icon)" :title="item.meta.title" />
        </el-menu-item>
      </app-link>
    </template>
    <el-submenu v-else ref="subMenu" :index="item.meta.fullPath" popper-append-to-body>
      <template slot="title">
        <m-item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item v-for="child in item.children" :key="child.path" :is-nest="true" :item="child"
       :base-path="child.path" class="nest-menu" />
    </el-submenu>
  </div>
</template>

<script>
import path from "path";
import { isExternal } from "@/utils/validate";
import mItem from "./item";
import appLink from "./link";

export default {
  name: "SidebarItem",
  components: { appLink, mItem },
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ""
    }
  },
  methods: {
    toggleSideBar() {
      if(this.$store.state.isMB) 
      this.$store.dispatch("toggleSideBar");
    }
  }
};
</script>
